export default {
	id: 'SIMPLE_PREMIUM_FALLBACK_1M_39_1W_4_79',
	providers: {
		paltaMap: {
			USD: 'simple_premium_1m_39_1w_4_79_usd',
			EUR: 'simple_premium_1m_39_1w_4_79_eur',
			GBP: 'simple_premium_1m_39_1w_4_79_gbp',
			AUD: 'simple_premium_1m_73_1w_8_79_aud',
			CAD: 'simple_premium_1m_73_1w_8_79_cad',
			DKK: 'simple_premium_1m_259_1w_31_2_dkk',
			SEK: 'simple_premium_1m_399_1w_47_2_sek',
			NOK: 'simple_premium_1m_399_1w_47_2_nok',
			BRL: 'simple_premium_1m_99_1w_20_79_brl',
			MXN: 'simple_premium_1m_649_1w_79_2_mxn',
			TRY: 'simple_premium_1m_999_1w_135_2_try',
			ARS: 'simple_premium_1m_51990_1w_6392_ars',
			COP: 'simple_premium_1m_157990_1w_19192_cop',
			CLP: 'simple_premium_1m_37990_1w_4792_clp',
		},
		primer: 'prd_dt0Ho0SdKz06',
	},
}
